module.exports = __webpack_public_path__ + "assets/img/plan5-3.31ce95ff.png";